"use strict";
import $http from '@/resource';
import utils from '@/utils';

const serverApi =  {
    get(formData,url){
        let promise;
        promise = new Promise(function (resolve, reject) {
            $http.get(url,{params:utils.filterData(formData)}).then(response => {
                if (response.code === 200) {
                    resolve(response.data);
                } else if (response.code === 401) {
                    reject(response);
                } else {
                    utils.notice(response.msg, 'info');
                    reject(response);
                }
            })
        });
        return promise;
    },
    post(formData,url){
        let promise;
        promise = new Promise(function (resolve, reject) {
            $http.post(url,utils.filterData(formData)).then(response => {
                if (response.code === 200) {
                    resolve(response);
                } else if (response.code === 401) {
                  reject(response);
                } else {
                    utils.notice(response.msg, 'info');
                    reject(response);
                }
            })
        });
        return promise;
    },
    put(formData,url){
        let promise;
        promise = new Promise(function (resolve, reject) {
            $http.put(url,formData).then(response => {
                if (response.code === 200) {
                    resolve(response);
                } else if (response.code === 401) {
                  reject(response);
                } else {
                    utils.notice(response.msg, 'info');
                    reject(response);
                }
            })
        });
        return promise;
    },
    patch(formData,url){
        let promise;
        promise = new Promise(function (resolve, reject) {
            $http.patch(url,utils.filterData(formData)).then(response => {
                if (response.code === 200) {
                    resolve(response);
                } else if (response.code === 401) {
                  reject(response);
                } else {
                    utils.notice(response.msg, 'info');
                    reject(response);
                }
            })
        });
        return promise;
    },
    delete(url){
        let promise;
        promise = new Promise(function (resolve, reject) {
            $http.delete(url).then(response => {
                if (response.code === 200) {
                    resolve(response);
                } else if (response.code === 401) {
                  reject(response
                    );
                } else {
                    utils.notice(response.msg, 'info');
                    reject(response);
                }
            })
        });
        return promise;
    },
    downLoadByPost(formData, url, fileName, isBlob = false){
        let promise;
        promise = new Promise(function (resolve, reject){
            if (isBlob){

                $http.post(url,utils.filterData(formData),{responseType: 'blob'}).then(res => {
                    let csvData = new Blob([res], { type: 'text/csv' });
                    if (window.navigator && window.navigator.msSaveOrOpenBlob){
                        window.navigator.msSaveOrOpenBlob(csvData, fileName);
                    }else{
                        if(res.type != "application/json"){
                            let blob = new Blob([res], {type: res.type})
                            let downloadElement = document.createElement('a')
                            let href = window.URL.createObjectURL(blob); //创建下载的链接
                            downloadElement.href = href;
                            downloadElement.download = fileName; //下载后文件名
                            document.body.appendChild(downloadElement);
                            downloadElement.click(); //点击下载
                            document.body.removeChild(downloadElement); //下载完成移除元素
                            window.URL.revokeObjectURL(href); //释放blob对象
                            resolve(res);
                        }else{
    
                            var reader = new FileReader();
                            reader.addEventListener("loadend", function () {
                                
                                if(JSON.parse(reader.result).code == 401){
                                    reject(JSON.parse(reader.result))
                                }else{
                                    utils.notice(JSON.parse(reader.result).msg, 'info');
    
                                    reject(JSON.parse(reader.result))
                                }
    
                            });
                            reader.readAsBinaryString(res)
                            // utils.notice("下载出错了", 'error')
                        }
                    }
                }).catch((error) => {
                    reject(error)
                    console.log(error)
                })
            }else{
                $http.post(url, utils.filterData(formData)).then(res => {
                    if (res.code == 200) {
                        let downloadElement = document.createElement('a')
                        let href = res.data.url; //创建下载的链接
                        downloadElement.href = href;
                        downloadElement.download = fileName; //下载后文件名
                        document.body.appendChild(downloadElement);
                        downloadElement.click(); //点击下载
                        document.body.removeChild(downloadElement); //下载完成移除元素
                        window.URL.revokeObjectURL(href); //释放blob对象
                        resolve(res);

                    } else {
                        utils.notice(res.msg, 'error');
                    }
                }).catch((error) => {
                    reject(error)
                    console.log(error)
                })
            }
        })
        return promise;
    },
    downLoadByGet(formData,url,fileName){
      $http.get(url,utils.filterData(formData),{responseType: 'blob'}).then(res => {
        let csvData = new Blob([res], { type: 'text/csv' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob){
          window.navigator.msSaveOrOpenBlob(csvData, fileName);
        }else{
          if(res.type != "application/json"){
            let blob = new Blob([res], {type: res.type})
            let downloadElement = document.createElement('a')
            let href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放blob对象
          }else{
            utils.notice("下载出错了", 'error')
          }
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    preview(formData, url, responseData, isBlob = false){
      let promise;
      promise = new Promise(function (resolve, reject) {
          $http.post(url, utils.filterData(formData), isBlob ? responseData : '').then(response => {
              if ((responseData && responseData.responseType == 'blob') || response.code == 200) {
                  resolve(response);
              } else {
                  reject(response)
              }
          return;
        }).catch((error) => {
          console.log(error)
        })
      });
      return promise;
    }
}
export  {serverApi}
